module.exports = __webpack_public_path__ + "img/sjs.92cbcc8c.png";